export enum PaymentSlipApprovalStatus {
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  REPROVED = 'reproved',
  APPROVED = 'approved',
  INITIAL = 'initial',
}
